import React, { useMemo, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { useSearchParams } from "react-router-dom";

export default function EntitiesTable({ data, rows }) {
  const [searchParams, setSearchParams] = useSearchParams();
  const [paginationModel, setPaginationModel] = useState({
    page: Number(searchParams.get("page") ?? 1) - 1,
    pageSize: Number(searchParams.get("page_size") ?? 50),
  });

  const handlePaginationModelChange = paginationModel => {
    searchParams.set("page", paginationModel.page + 1);
    searchParams.set("page_size", paginationModel.pageSize);

    setSearchParams(searchParams);
    setPaginationModel(paginationModel);
  };

  const columns = useMemo(
    () => [
      {
        headerName: "Filial",
        field: "subsidiary",
        flex: 1,
        renderCell: params => params.row?.RA0_FILIAL,
      },
      {
        headerName: "Código",
        field: "code",
        flex: 1,
        renderCell: params => params.row?.RA0_ENTIDA,
      },
      {
        headerName: "Descrição",
        field: "description",
        flex: 2,
        renderCell: params => params.row?.RA0_DESC,
      },
      {
        headerName: "CPF/CNPJ",
        field: "cpfCnpj",
        flex: 1,
        renderCell: params => params.row?.RA0_CGC,
      },
      {
        headerName: "Cidade",
        field: "city",
        flex: 1,
        renderCell: params => params.row?.RA0_CIDADE,
      },
      {
        headerName: "UF",
        field: "state",
        flex: 0.5,
        renderCell: params => params.row?.RA0_ESTADO,
      },
    ],
    [searchParams, setSearchParams],
  );

  return (
    <DataGrid
      rows={data}
      columns={columns}
      getRowId={row => row.R_E_C_N_O_}
      sx={{ flex: 1, border: "none" }}
      disableColumnMenu
      disableColumnFilter
      disableColumnSelector
      disableRowSelectionOnClick
      rowCount={rows}
      paginationMode="server"
      paginationModel={paginationModel}
      onPaginationModelChange={handlePaginationModelChange}
    />
  );
}
